import { ContainerTrainCarrier } from '@api/queries/inventory';
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import DetailsInput from './DetailsInput';

interface Props extends WithTranslation {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  containerTrain?: ContainerTrainCarrier;
  trafficOut: boolean;
  isDisabled?: boolean;
}

const ContainerTrain = ({ isDisabled, containerTrain, onChange, t }: Props) => {
  const { containerNumber, billOfLandingNumber, reference } = containerTrain || {
    containerNumber: '',
    billOfLandingNumber: '',
    reference: ''
  };

  return (
    <>
      <DetailsInput
        name="containerNumber"
        label={t('entry.containerTrain.container_number')}
        isDisabled={isDisabled}
        value={containerNumber}
        onChange={onChange}
      />
      <DetailsInput
        name="billOfLandingNumber"
        label={t('entry.containerTrain.bill_of_landing_number')}
        isDisabled={isDisabled}
        value={billOfLandingNumber}
        onChange={onChange}
      />
      <DetailsInput
        name="reference"
        label={t('entry.containerTrain.reference')}
        isDisabled={isDisabled}
        value={reference}
        onChange={onChange}
      />
    </>
  );
};

export default withTranslation()(ContainerTrain);
